module.exports = __webpack_public_path__ + "img/logo_footer.4c2dcb70.png";